import { useParams } from 'react-router-dom';
import { ComparaisonDepenses } from '../../components/ndf/ComparaisonDepenses';

/**
 * Comparaison de deux dépenses signalées comme doublons.
 *
 * La page ne fait que porter l'URL : la comparaison elle-même vit dans un
 * composant partagé avec l'écran de validation. Un doublon se tranche de la
 * même façon des deux côtés, il n'y a aucune raison de l'écrire deux fois.
 */
export function NdfComparerPage() {
  const { id = '', autreId = '' } = useParams();
  return <ComparaisonDepenses idA={id} idB={autreId} />;
}
